import SVGAttributeSetter from './ma-icon-svg-attribute-setter';

export default {
    render(createElement) {
        return createElement('span');
    },
    props: {
        svg: {
            required: true,
            validator(value) {
                const isString = typeof value === 'string';
                const isESModule = typeof value === 'object' && value.__esModule === true;

                return isString || isESModule;
            }
        },
        inheritFillFromParent: {
            type: Boolean,
            default: true
        },
        assistiveText: {
            type: String
        },
        iconClass: {
            type: [Array, String]
        }
    },
    mounted() {
        const _svg = (typeof this.svg === 'object' && this.svg.__esModule === true) ? this.svg.default : this.svg;
        const fragment = document.createRange().createContextualFragment(_svg);
        const svg = Array.from(fragment.childNodes).find(child => child.nodeName === 'svg');

        if (!svg) {
            console.error('Could not build SVG.');
            return;
        }

        SVGAttributeSetter.call(this, svg);
    }
};
